<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-row>
      <b-col sm="" lg="6">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-ativos"
            >
              <i class="fa fa-info-circle fa-lg tamanhoIcon"></i>
            </b-button>
            <h4 class="mb-0">{{ cuponsAtivos }}</h4>
            <p>Cupons ativos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-visualizados"
            >
              <i class="fa fa-info-circle fa-lg"></i>
            </b-button>
            <h4 class="mb-0">{{ cuponsExpirados }}</h4>
            <p>Cupons expirados</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <nav>
                <b-pagination
                  :total-rows="getRowCount(items)"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Anterior"
                  next-text="Próxima"
                />
              </nav>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-button
                variant="success"
                class="botaoCadastrarCupom"
                @click="redirect"
                >Cadastrar novo cupom</b-button
              >
            </b-col>
          </b-row>
          <b-table
            v-if="items.length > 0"
            :items="items"
            :fields="fields"
            bordered
            striped
            hover
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(enviada)="data">
              <b-badge v-if="data.item.enviada == false" variant="danger">
                {{ data.item.enviada == false ? "Não" : "Sim" }}
              </b-badge>
              <b-badge v-else variant="success">
                {{ data.item.enviada == false ? "Não" : "Sim" }}
              </b-badge>
            </template>
          </b-table>
          <div class="text-center f-g" v-else>
            <i class="fa fa-frown-o fa-custom-size"></i>
            <h4>Desculpe, não encontramos nenhum cupom :(</h4>
            <h5>Para iniciar, clique no botão acima e comece os cadastros!</h5>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "Cupons",
  components: {
    Loading,
  },
  data: function () {
    return {
      isLoading: false,
      temPromocoes: false,
      numCampanhas: 0,
      titulo: "",
      descricao: "",
      items: [],
      fields: [
        { key: "titulo", label: "Título" },
        { key: "descricao", label: "Descrição" },
        { key: "datahoracadastro", label: "Data de criação" },
        { key: "enviada", label: "Cupom enviado" },
        { key: "qtdclientesselecionados", label: "Clientes selecionados" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      cuponsExpirados: 0,
      descontoTotal: 0,
      cuponsUtilizados: 0,
      cuponsAtivos: 0,
      pacoteAdicional: 0,
      modalShow: false,
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },
    redirect() {
      localStorage.setItem("tipoid", 5);
      this.$router.push({ path: `/cadastrar-cupom` });
    },

    async getTotalizadores() {
      const url = `${
        config.default.servidor
      }/gerencial/totalizadores-cupom/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });
        if (response.status == 200) {
          this.cuponsAtivos = response.data.ativos;
          this.cuponsUtilizados = response.data.utilizados;
          this.cuponsExpirados = response.data.expirados;
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async getCupons() {
      const url = `${
        config.default.servidor
      }/gerencial/cupom/${localStorage.getItem("enterprise_id")}`;
      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.items = response.data.data;
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getTotalizadores();
    await this.getCupons();
    this.isLoading = false;
  },
};
</script>
